import hardwareListeners from './hardwareListeners';
import { mutationTypes } from '../../../types';
import packageJSON from '../../../../package.json';

export default {
	state: {
		batteryState: 'unkown',
		batteryLevel: -1,
		deviceName: 'unkown',
		deviceModel: 'unkown',
		deviceOS: 'unkown',
		deviceOsVersion: null,
		deviceBluetoothMac: 'unkown',
		deviceWifiMac: 'unkown',
		appVersion: -1,
		appIsLoaner: -1,
		appIsIOS: false,
		appApiVersion: -1,
		appNeedsVolumeControl: false,
		headPhonePlugged: null,
		wcVersion: `'${packageJSON.version}'`,
	},
	getters: {},
	mutations: {
		[mutationTypes.systemSetHeadPhoneState](state, { pluggedHeadphones }) {
			state.appIsHeadPhonePlugged = pluggedHeadphones;
		},
		[mutationTypes.systemSetBatteryState](state, { batteryState }) {
			state.batteryState = batteryState;
		},
		[mutationTypes.systemSetBatteryLevel](state, { batteryLevel }) {
			state.batteryLevel = batteryLevel;
		},
		[mutationTypes.systemSetDeviceInfo](state, { deviceInfo }) {
			state.deviceName = deviceInfo.deviceName;
			state.deviceModel = deviceInfo.deviceModel;
			state.deviceOS = deviceInfo.deviceOS;
			state.deviceOsVersion = deviceInfo.deviceOsVersion;
			state.deviceBluetoothMac = deviceInfo.deviceBluetoothMac;
			state.deviceWifiMac = deviceInfo.deviceWifiMac;
			state.deviceModel = deviceInfo.deviceModel;
		},
		[mutationTypes.systemSetAppInfo](state, { appInfo }) {
			state.appIsLoaner = appInfo.appIsLoaner;
			state.appIsIOS = appInfo.appIsIOS;
			state.appApiVersion = appInfo.appApiVersion;
			state.appVersion = appInfo.appVersion;
			state.appNeedsVolumeControl = appInfo.appNeedsVolumeControl;
		},
	},
	actions: {},
	plugins: [hardwareListeners],
};
